/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcelVo } from './ParcelVo';
import {
    ParcelVoFromJSON,
    ParcelVoFromJSONTyped,
    ParcelVoToJSON,
    ParcelVoToJSONTyped,
} from './ParcelVo';

/**
 * 
 * @export
 * @interface ResponseListParcelVo
 */
export interface ResponseListParcelVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListParcelVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListParcelVo
     */
    message?: string;
    /**
     * 
     * @type {Array<ParcelVo>}
     * @memberof ResponseListParcelVo
     */
    data?: Array<ParcelVo>;
}

/**
 * Check if a given object implements the ResponseListParcelVo interface.
 */
export function instanceOfResponseListParcelVo(value: object): value is ResponseListParcelVo {
    return true;
}

export function ResponseListParcelVoFromJSON(json: any): ResponseListParcelVo {
    return ResponseListParcelVoFromJSONTyped(json, false);
}

export function ResponseListParcelVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListParcelVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ParcelVoFromJSON)),
    };
}

export function ResponseListParcelVoToJSON(json: any): ResponseListParcelVo {
    return ResponseListParcelVoToJSONTyped(json, false);
}

export function ResponseListParcelVoToJSONTyped(value?: ResponseListParcelVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ParcelVoToJSON)),
    };
}

